module.exports = __webpack_public_path__ + "img/calendar.cc4db572.svg";